import * as React from "react";
const SvgFiRrKnitting = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-knitting_svg__a)">
      <path
        fill="#062147"
        d="M21.5 4.5A2.5 2.5 0 0 0 19 7c0 .142.019.279.042.415l-2.91 2.116a9 9 0 0 0-2.222-2.065l1.369-2.489c.074.007.146.022.222.022a2.5 2.5 0 1 0-2.5-2.5c0 .573.201 1.095.525 1.517l-1.404 2.553A8.9 8.9 0 0 0 9.001 6C4.037 6 0 10.038 0 15s4.037 9 9 9 9-4.037 9-9a8.9 8.9 0 0 0-.779-3.645c-.006-.018-.017-.033-.024-.05l-.027-.056 2.966-2.157A2.5 2.5 0 1 0 21.5 4.5m-7.585 5.523a7 7 0 0 1 1.228 1.625c-.845 1.442-2.419 2.828-4.21 3.706a4.4 4.4 0 0 1-1.442-1.635 10.75 10.75 0 0 0 4.424-3.695zM9.862 8.058a6.9 6.9 0 0 1 2.447.776 8.75 8.75 0 0 1-3.295 2.898c-.003-.079-.015-.151-.015-.232a7.4 7.4 0 0 1 .863-3.441zm-.863 13.941c-3.859 0-7-3.141-7-7 0-1.333.382-2.576 1.031-3.638-.013.212-.031.424-.031.638 0 4.763 3.351 8.753 7.817 9.752a7 7 0 0 1-1.817.248m4.938-2.045a9 9 0 0 1-.938.045c-4.411 0-8-3.589-8-8 0-1.081.211-2.127.627-3.11q.002-.011.005-.022a7 7 0 0 1 2.004-.732A9.4 9.4 0 0 0 7 11.499c0 2.544 1.15 4.518 3.219 5.759.099.083.208.15.329.19 1.2.645 2.677 1.063 4.402 1.219a7 7 0 0 1-1.012 1.288zm1.84-3.238a12.7 12.7 0 0 1-2.557-.362 12.5 12.5 0 0 0 2.698-2.366c.048.331.082.667.082 1.011 0 .594-.082 1.167-.222 1.718z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-knitting_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrKnitting;
